import { useEffect, useMemo, useState } from 'react';

import { useCurrentUser, useData } from '../../data/DataContext.tsx';
import type { ThreadView } from '../../data/ports.ts';
import { useAccount } from '../account/AccountContext.tsx';

// Shops whose messages you answer: the ones you own or manage.
export function useInboxShopIds(): string[] {
  const { shops } = useAccount();
  const key = shops.filter(shop => shop.role === 'owner' || shop.role === 'manager').map(shop => shop.shopId).sort().join(',');
  return useMemo(() => (key ? key.split(',') : []), [key]);
}

// Unread notifications and messages for the shell's badges, live.
export function useSocialCounts(): { notifications: number; messages: number } {
  const { social } = useData();
  const user = useCurrentUser();
  const [counts, setCounts] = useState({ uid: '', notifications: 0, messages: 0 });
  const uid = user?.uid ?? '';
  const shopIds = useInboxShopIds();
  useEffect(() => {
    if (!uid) return;
    const stopNotifications = social.watchNotifications(items => setCounts(current => ({ ...current, uid, notifications: items.filter(item => !item.read && item.type !== 'message').length })), () => undefined);
    const stopThreads = social.watchThreads((threads: ThreadView[]) => setCounts(current => ({ ...current, uid, messages: threads.filter(thread => thread.unread > 0).length })), () => undefined, shopIds);
    return () => { stopNotifications(); stopThreads(); };
  }, [social, uid, shopIds]);
  return counts.uid === uid && uid ? counts : { notifications: 0, messages: 0 };
}
